import { createContext, useContext } from 'react';

/**
 * MockDashboardDataProvider - Simulates dashboard data for UI testing
 * 
 * IMPORTANT: This is ONLY for UI Harness mode
 * Provides mock wallet, campaigns, and analytics data
 */

const MockDashboardDataContext = createContext(null);

// Export hook with same name as real context
export function useDashboardData() {
  return useContext(MockDashboardDataContext);
}

export function MockDashboardDataProvider({ children, scenario = 'default' }) {
  // Mock wallet data
  const mockWallet = {
    balance_cents: 1250, // $12.50
    sms_remaining: 425,
    currency: 'AUD',
  };

  // Mock campaigns
  const mockCampaigns = [
    {
      id: 'camp_1',
      name: 'Weekend Special Promotion',
      status: 'completed',
      recipient_count: 150,
      sent_count: 150,
      delivered_count: 148,
      failed_count: 2,
      created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: 'camp_2',
      name: 'New Menu Launch',
      status: 'completed',
      recipient_count: 200,
      sent_count: 200,
      delivered_count: 195,
      failed_count: 5,
      created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: 'camp_3',
      name: 'Holiday Hours Update',
      status: 'draft',
      recipient_count: 0,
      sent_count: 0,
      delivered_count: 0,
      failed_count: 0,
      created_at: new Date().toISOString(),
    },
  ];

  // Mock analytics
  const mockAnalytics = {
    total_campaigns: 12,
    total_sms_sent: 3450,
    total_delivered: 3398,
    delivery_rate: 98.5,
    total_spend_cents: 8625,
    avg_campaign_size: 287,
  };

  const value = {
    isInitialLoadComplete: true,
    walletStatus: mockWallet,
    recentCampaigns: mockCampaigns,
    analyticsOverview: mockAnalytics,
    refreshDashboard: async () => console.log('[UI Harness] Mock refresh dashboard'),
  };

  return (
    <MockDashboardDataContext.Provider value={value}>
      {children}
    </MockDashboardDataContext.Provider>
  );
}
